module.exports = __webpack_public_path__ + "media/media/values/values-01-4a2ecf5ad2499b3ded3dc09a90816d51.jpg";